// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailsBillInputs_oiNJ2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  input {
    outline: none;
    border: none;
    background-color: var(--f4-background);
    color: var(--_75-color);
    padding: 12px;
    box-sizing: border-box;
  }
  input::placeholder {
    color: var(--_75-color);
  }
}
.row_c8hLq {
  width: 100%;
  font-weight: 500;
  color: var(--_2-color);
}
.containerColumn_HMguL {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  gap: 10px;
  > div {
    flex: 1 1;
    box-sizing: border-box;
    font-weight: 500;
  color: var(--_2-color);
  }
}
.defaultAddress_GwUfw {
  display: flex;
  width: 100%;
  justify-content: end;
  align-items: center;
  span {
    color: #2ebc89 !important;
  }
}

.iconToggle_yVEFF{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoContact/DetailsBillInputs/DetailsBillInputs.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,aAAa;IACb,YAAY;IACZ,sCAAsC;IACtC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT;IACE,SAAO;IACP,sBAAsB;IACtB,gBAAgB;EAClB,sBAAsB;EACtB;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".DetailsBillInputs {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  input {\n    outline: none;\n    border: none;\n    background-color: var(--f4-background);\n    color: var(--_75-color);\n    padding: 12px;\n    box-sizing: border-box;\n  }\n  input::placeholder {\n    color: var(--_75-color);\n  }\n}\n.row {\n  width: 100%;\n  font-weight: 500;\n  color: var(--_2-color);\n}\n.containerColumn {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 10px;\n  > div {\n    flex: 1;\n    box-sizing: border-box;\n    font-weight: 500;\n  color: var(--_2-color);\n  }\n}\n.defaultAddress {\n  display: flex;\n  width: 100%;\n  justify-content: end;\n  align-items: center;\n  span {\n    color: #2ebc89 !important;\n  }\n}\n\n.iconToggle{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DetailsBillInputs": `DetailsBillInputs_oiNJ2`,
	"row": `row_c8hLq`,
	"containerColumn": `containerColumn_HMguL`,
	"defaultAddress": `defaultAddress_GwUfw`,
	"iconToggle": `iconToggle_yVEFF`
};
export default ___CSS_LOADER_EXPORT___;
